"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormDurationSelect", {
    enumerable: true,
    get: function() {
        return FormDurationSelect;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _useDurationIconBackground = require("./useDurationIconBackground");
const _FormSelect = require("../FormSelect/FormSelect");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormDurationSelect = (param)=>{
    let { children, ...props } = param;
    return /*#__PURE__*/ _react.default.createElement(_FormSelect.FormSelect, {
        dropdownIcon: _useDurationIconBackground.useDurationIconBackground,
        ...props
    }, children);
};

//# sourceMappingURL=FormDurationSelect.js.map